<template>
  <button
    :disabled="disabled || loading"
    @click="handleClick"
    :class="{loading}"
  >
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'BtnAction',
    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      },
      success: {
        type: Function,
        default: () => () => {},
      },
      error: {
        type: Function,
        default: () => () => {},
      },
      delay: {
        type: Number,
        default: () => 1000,
      },
    },
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      handleClick (...args) {
        const res = this.$listeners.click(...args)

        if (!(res instanceof Promise)) {
          this.loading = false
          return this.success()
        }

        this.loading = true
        res
          .then(
            () => {
              setTimeout(() => { this.loading = false }, this.delay)
              this.success()
            },
            e => {
              setTimeout(() => { this.loading = false }, this.delay)
              this.error()
            },
          )
      },
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/btn-action.vue